import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackButtonContainer, BackButtonLabel } from "./styled";
import { Icon } from "../Icon";
export const BackButton = ({ label, onClick, ...rest }) => {
    return (_jsxs(BackButtonContainer, { onClick: onClick, ...rest, children: [_jsx(Icon, { icon: "left" }), label && (_jsx(BackButtonLabel, { children: label }))] }));
};
